package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/**
 * A hairline-ruled row inside a Field panel: text left, mono timestamp or [trailing] slot right.
 * Used for the submission wire, "still in the locker room", and similar lists.
 */
@Composable
fun FeedRow(text: String, modifier: Modifier = Modifier, meta: String? = null, trailing: (@Composable () -> Unit)? = null) {
  Div(
    attrs = Modifier
      .typeBody("13px", 500, "1.35")
      .css("display" to "grid", "grid-template-columns" to "minmax(0,1fr) auto", "gap" to "10px",
        "align-items" to "center", "padding" to "7px 0", "border-top" to "1px solid ${SwColor.hairlineSoft}")
      .then(modifier)
      .toAttrs()
  ) {
    Span { Text(text) }
    when {
      trailing != null -> trailing()
      meta != null -> Span(attrs = Modifier.typeMono().css("color" to "rgba(239,229,201,.55)").toAttrs()) { Text(meta) }
    }
  }
}
